module.exports = __webpack_public_path__ + "img/wx_img.14414cfe.png";